import { equipmentAPI } from "api";

export const getEquipmentActionListAPI = (payload) => {
    console.log("equipmentAPI", equipmentAPI)
    return equipmentAPI.post(`/api/equipmentaction?ActionDateFrom=${payload?.newfromDate}&ActionDateTo=${payload?.newtoDate}&ActionType=${payload?.actionDropDown}`, {
        "filterParams": [
        ]
    })
        .then((res) => res);
}